import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeedState } from './feed.state';
import { CommunityTabType } from '../../interfaces';

export const selectFeedState = createFeatureSelector<FeedState>('feed');

export const selectAllTabs = createSelector(selectFeedState, state => state.tabs);

export const selectTabData = (tabId: CommunityTabType) =>
  createSelector(selectFeedState, state => state.tabs[tabId] || null);

export const selectTabItems = (tabId: CommunityTabType) =>
  createSelector(selectTabData(tabId), tabData => tabData?.items || []);

export const selectTabLoading = (tabId: CommunityTabType) =>
  createSelector(selectTabData(tabId), tabData => tabData?.isLoading || false);

export const selectTabHasMore = (tabId: CommunityTabType) =>
  createSelector(selectTabData(tabId), tabData => tabData?.hasMore || false);

export const selectTabScrollPosition = (tabId: CommunityTabType) =>
  createSelector(selectTabData(tabId), tabData => tabData?.scrollPosition || 0);

export const selectLastViewedPost = (tabId: CommunityTabType) =>
  createSelector(selectTabData(tabId), tabData => tabData?.lastViewedPostId);

export const selectTargetPost = (tabId: CommunityTabType) =>
  createSelector(selectTabData(tabId), tabData => tabData?.targetPostId);

export const selectLastActiveTab = createSelector(selectFeedState, state => state.lastActiveTab);
